<template>
  <div :class="{ 'detail-zhiyun-version': versionConfig.ZHIYUN_VERSION }">
    <head-nav-bar title="订单详情" :fixed="true">
      <template slot="right" v-if="!companyId">
        <van-dropdown-menu>
          <van-dropdown-item title="…" ref="item">
            <van-cell-group class="order-drop-menu">
              <van-cell
                title="暂离"
                is-link
                v-if="canTempLeave"
                @click="checkOut(3)"
              />
              <van-cell
                title="联房"
                is-link
                v-if="canUnitRoom"
                @click="
                  $router.push({ name: 'UnitRoom', query: { id: orderId } })
                "
              />
              <van-cell
                title="拆联"
                is-link
                v-if="canSplitRoom"
                @click="
                  $router.push({ name: 'SplitRoom', query: { id: orderId } })
                "
              />
              <van-cell
                title="订单日志"
                is-link
                @click="
                  $router.push({ name: 'OrderLog', query: { id: orderId } })
                "
              />
              <van-cell
                is-link
                v-if="orderInfo.Status == 0 && isShowCancel"
                title="取消订单"
                @click="orderCancle"
              />
              <van-cell
                is-link
                v-if="orderInfo.Status == 4 && !canUnitRoom"
                span="24"
                title="恢复订单"
                @click="orderRecover"
              />
              <van-cell
                is-link
                v-if="
                  (orderInfo.Status == 0 ||
                    orderInfo.Status == 1 ||
                    orderInfo.Status == 3) &&
                    defaultItem &&
                    defaultItem.UsingNewTransferProcess == '1'
                "
                title="转账"
                @click="onTransferEntry"
              />
              <!-- <van-cell is-link title="冲账" />
              <van-cell is-link title="押金单" /> -->
            </van-cell-group>
          </van-dropdown-item>
        </van-dropdown-menu>
      </template>
    </head-nav-bar>
    <div class="mt-header-nav">
      <div class="info-box">
        <van-row class="title">
          <van-col span="12">
            订单信息
            <van-tag v-if="orderInfo.OrderAttr == 2" round color="#ff8800"
              >补录订单</van-tag
            >
          </van-col>
          <van-col span="12" class="amount">
            <van-tag type="danger" v-if="orderInfo.Status == '4'"
              >已取消</van-tag
            >

            <van-tag
              type="success"
              style="margin-right:2px"
              v-else-if="orderInfo.Status == '2'"
              >已完成</van-tag
            >

            待收金额：<span class="amountColor">
              {{ orderInfo.NeedToPayAmount }}
            </span>
          </van-col>
        </van-row>
        <van-row class="contact">
          <van-col span="19">
            {{ orderInfo.Contact }}
            <span class="phone"
              >{{ orderInfo.Phone ? orderInfo.Phone : "未留电话" }}
              {{ orderInfo.PhoneLocation }}</span
            >
            <!-- <span class="address">江西南昌</span> -->
          </van-col>
          <van-col span="5" class="text-right">
            <van-icon
              :name="contactIcon"
              size="20"
              :class="{ contacted: orderInfo.HasContacted }"
              style="margin-right: 10px;"
              @click="ContactGuest(orderInfo.HasContacted)"
            />
            <van-icon
              name="phone"
              size="21"
              v-if="orderInfo.Phone"
              @click="onCall(orderInfo.Phone)"
            />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="11">
            <label> 订单号</label>：<span>{{ orderInfo.OrderNo }}</span>
          </van-col>
          <van-col span="13">
            <label>价类</label>：<span>{{ orderInfo.PriceCodeName }}</span>
          </van-col>
          <van-col span="11">
            <label> 业务员</label>：<span>{{ orderInfo.SalesmanName }}</span>
          </van-col>
          <van-col span="13">
            <label>会员卡</label>：<span
              style="color:#1989fa;text-decoration: underline;"
              @click="jumpToMember"
              >{{ orderInfo.MemberName }}</span
            >
          </van-col>
          <van-col span="11">
            <label> 渠道</label>：<span>{{ orderInfo.ChannelName }}</span>
          </van-col>
          <van-col span="13">
            <label> 渠道单号</label>：<span>{{
              orderInfo.ChannelOrderNo
            }}</span>
          </van-col>
          <van-col span="24" v-if="orderInfo.CustomerName">
            <label> 客户</label>：<span>{{ orderInfo.CustomerName }}</span>
          </van-col>
          <van-col span="24" v-if="orderInfo.ContactRemark">
            <label>备注</label>：
            <span class="remark">
              {{ orderInfo.ContactRemark }}
            </span>
          </van-col>
        </van-row>
      </div>
      <div class="info-box">
        <van-row class="title">
          <van-col span="14">
            房间信息
            <small style="color:#333;margin-left:10px;font-weight:bold;"
              >预计房费：<em style="color:#f00;font-size:14px">{{
                orderInfo.OrderTotalRoomPrice
              }}</em></small
            ></van-col
          >
          <van-col span="10" class="amount">
            消费金额：
            <span class="amountColor">{{ orderInfo.TotalAmount }}</span>
          </van-col>
        </van-row>
        <div style="height: 150px;overflow: auto;">
          <div
            v-for="(item, index) in orderInfo.Details"
            :key="index"
            class="room-content"
          >
            <van-row class="room-item">
              <van-col :span="item.OrderStatus != 1 ? 12 : 10" class="name">
                {{ item.RoomTypeName }}-{{
                  item.RoomNo ? item.RoomNo : "未排房"
                }}
              </van-col>
              <van-col span="3">
                {{ item.TotalRoomPrice }}
              </van-col>
              <van-col span="4" style="text-align:right"
                ><van-tag plain type="primary"
                  >证件*{{ item.IDCardCount }}</van-tag
                >
              </van-col>
              <van-col :span="item.OrderStatus != 1 ? 5 : 3" class="status">
                {{ item.StatusName }}
              </van-col>
              <van-col span="3" v-if="item.OrderStatus == 1">
                <van-button
                  type="primary"
                  size="mini"
                  block
                  style="margin-left:5px"
                  v-if="!orderInfo.IsHourRoom"
                  @click="orderExtend(item)"
                  >续住</van-button
                >
                <van-button
                  type="primary"
                  size="mini"
                  block
                  style=" margin-top:1px;margin-left:5px"
                  @click="orderRevoke(item)"
                  >撤销</van-button
                >
              </van-col>
            </van-row>
            <van-row class="check-date">
              <van-col span="11">
                住店:
                <span v-if="orderInfo.IsHourRoom && item.OrderStatus == 0">
                  {{ item.CheckInDate }}
                </span>
                <span
                  v-else-if="orderInfo.IsHourRoom && orderInfo.OrderAttr != 2"
                >
                  {{ item.OperationInTime }}
                </span>
                <span v-else>
                  {{
                    defaultItem.isShowTime || orderInfo.IsHourRoom
                      ? item.CheckInTime
                      : item.CheckInDate
                  }}
                </span>
              </van-col>
              <van-col span="10">
                {{ item.OrderStatus == 2 ? "离店" : "预离" }}:
                <span v-if="orderInfo.IsHourRoom && item.OrderStatus == 0">
                  {{ item.CheckOutDate }}
                </span>
                <span v-else>
                  {{
                    defaultItem.isShowTime || orderInfo.IsHourRoom
                      ? item.CheckOutTime
                      : item.CheckOutDate
                  }}
                </span>
              </van-col>
              <van-col span="3">
                共
                <em style="color:#f00;font-style:normal">{{ item.diffDay }}</em>
                晚
              </van-col>
            </van-row>
            <van-collapse
              class="consume-detail"
              v-model="activeNames"
              v-if="item.Consumes.length > 0"
              :border="false"
            >
              <van-collapse-item title="消费明细" :name="1 + index">
                <div class="amount" slot="value">
                  <span
                    >显示全部：<van-switch
                      size="16px"
                      class="show-all"
                      @click.stop="onClick"
                      v-model="showAllAccount"
                  /></span>
                  <span style="color:#f00;">{{ item.total }}</span>
                </div>
                <table>
                  <tr>
                    <th>项目</th>
                    <th>单价</th>
                    <th>单据号</th>
                    <th>日期</th>
                    <th>金额</th>
                  </tr>
                  <tbody>
                    <template v-for="(item1, index1) in item.Consumes">
                      <tr
                        v-if="
                          (!showAllAccount &&
                            item1.Sign != 'X' &&
                            item1.ExtraSign != 'O') ||
                            showAllAccount
                        "
                        :key="index1"
                        :class="{
                          revoke: item1.Sign == 'X',
                        }"
                      >
                        <td>
                          <van-tag
                            v-if="item1.TransferRemark"
                            :type="
                              item1.ExtraSign == 'O' ? 'warning' : 'primary'
                            "
                            @click="viewTransferRecords(item1)"
                            style="margin-right:1px"
                          >
                            {{ item1.ExtraSign == "O" ? "转出" : "转入" }}
                          </van-tag>
                          <van-tag
                            v-if="item1.Sign == 'X'"
                            color="red"
                            style="margin-right:1px"
                            plain
                          >
                            冲账
                          </van-tag>
                          {{ item1.AccountItemName }}*{{ item1.Quantity }}
                        </td>
                        <td>{{ item1.UnitPrice }}</td>
                        <td>{{ item1.BillNo }}</td>
                        <td>{{ moment(item1.AccountDate).format("MM/DD") }}</td>
                        <td style="text-align:right">{{ item1.TotalPrice }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
      <div class="info-box">
        <!-- <p
          v-if="orderInfo.InvoiceNumber"
          style="color: #d58f00;margin: -5px 0 5px;"
        >
          发票号：{{ orderInfo.InvoiceNumber }}
        </p> -->
        <van-collapse
          class="consume-detail pay-detail"
          v-model="payActiveNames"
          :border="false"
        >
          <van-collapse-item title="收付款信息" name="1">
            <div class="amount" slot="value">
              <span
                >显示全部：<van-switch
                  size="16px"
                  class="show-all"
                  @click.stop="onClick"
                  v-model="showAllPay"
              /></span>
              已收金额：<span class="amountColor">{{
                orderInfo.AlreadyPayAmount
              }}</span>
            </div>
            <table>
              <tr>
                <th width="30%">付款方式</th>
                <th width="15%">单据号</th>
                <th width="25%">客户/会员</th>
                <!-- <th>备注</th> -->
                <th>日期</th>
                <th width="15%">金额</th>
              </tr>
              <template v-for="(item, index) in orderInfo.Pays">
                <tr
                  v-if="
                    (!showAllPay &&
                      item.Sign != 'X' &&
                      item.ExtraSign != 'O') ||
                      showAllPay
                  "
                  :key="index"
                  :class="{
                    revoke: item.Sign == 'X',
                  }"
                >
                  <td>
                    <van-tag
                      v-if="item.TransferRemark"
                      :type="item.ExtraSign == 'O' ? 'warning' : 'primary'"
                      @click="viewTransferRecords(item)"
                      style="margin-right:1px"
                    >
                      {{ item.ExtraSign == "O" ? "转出" : "转入" }}
                    </van-tag>
                    <van-tag
                      v-if="item.Sign == 'X'"
                      color="red"
                      style="margin-right:1px"
                      plain
                    >
                      冲账 </van-tag
                    >{{ item.AccountItemName }}
                  </td>
                  <td>{{ item.BillNo }}</td>
                  <td>{{ item.TargetName }}</td>
                  <!-- <td>{{ item.AccountRemark }}</td> -->
                  <td>{{ moment(item.AccountDate).format("MM/DD") }}</td>
                  <td style="text-align:right">{{ item.TotalPrice }}</td>
                </tr>
              </template>
            </table>
          </van-collapse-item>
        </van-collapse>
      </div>
      <van-goods-action v-if="!companyId">
        <template slot="default">
          <van-row style="width:100%" :gutter="1">
            <van-col span="5">
              <van-button
                type="info"
                :disabled="!isShowEdit || !$auth('WalkingOrder:Update')"
                size="large"
                @click="updateOrder"
              >
                修改订单
              </van-button>
            </van-col>
            <van-col span="5">
              <van-button
                type="info"
                :disabled="
                  (orderInfo.Status != 0 &&
                    orderInfo.Status != 1 &&
                    !isTempLeaveStatus) ||
                    !$auth('WalkingOrder:AddPay')
                "
                size="large"
                @click="cashDesk"
              >
                收银
              </van-button>
            </van-col>

            <van-col span="4">
              <van-button
                :disabled="
                  (orderInfo.Status != 1 && !isTempLeaveStatus) ||
                    !$auth('WalkingOrder:AddConsume')
                "
                type="info"
                size="large"
                @click="inAccount"
              >
                入账
              </van-button>
            </van-col>

            <van-col span="5">
              <van-button
                :disabled="!isShowCheckIn || !$auth('WalkingOrder:CheckIn')"
                type="info"
                size="large"
                @click="checkIn"
              >
                办理入住
              </van-button>
            </van-col>

            <van-col span="5">
              <van-button
                :disabled="
                  (orderInfo.Status != 1 && !isTempLeaveStatus) ||
                    !$auth('WalkingOrder:SettleCheckOut')
                "
                type="info"
                size="large"
                @click="checkOut(1)"
              >
                办理退房
              </van-button>
            </van-col>
          </van-row>
        </template>
      </van-goods-action>
    </div>
    <van-dialog
      v-model="visiblePrice"
      title="选择转续住日房价"
      @confirm="submitExtend"
      show-cancel-button
    >
      <div class="extend-price">
        <van-radio-group v-model="extendValue">
          <van-radio name="1">
            <span class="txt-label"> 自定义</span>
            <van-field
              class="txt"
              v-if="extendValue == 1"
              v-model="extendPrice"
              type="number"
            />
          </van-radio>
          <van-radio name="2">系统房价</van-radio>
        </van-radio-group>
        <div class="extend-days">
          <van-field
            readonly
            clickable
            label="续住房晚"
            :value="extendDays"
            placeholder="续住房晚"
            @click="showPicker = true"
          />
          <van-popup
            v-model="showPicker"
            round
            position="bottom"
            :get-container="getContainer"
          >
            <van-picker
              show-toolbar
              :columns="extendDaysData"
              @cancel="showPicker = false"
              @confirm="confirmExtendDays"
            />
          </van-popup>
          <van-button type="primary" size="small" @click="openDate">
            日历</van-button
          >
        </div>
      </div>
    </van-dialog>
    <van-popup
      v-model="showDate"
      round
      position="bottom"
      :get-container="getContainer"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="chooseDate"
      />
    </van-popup>
    <TransferRecords ref="TransferRecords"></TransferRecords>
  </div>
</template>

<script>
import moment from "moment";
import orderApi from "../../api/order.js";
import groupOrderApi from "../../api/group_order.js";
import { jump } from "../../utils/common";
import { mapState, mapActions } from "vuex";
import cloneDeep from "lodash/cloneDeep";
import { GetDefaultItem } from "@/api/common.js";
import TransferAccountModal from "./transferAccount/";
import "moment/locale/zh-cn";
import TransferRecords from "./transferAccount/TransferRecords";
import {
  Row,
  Col,
  Icon,
  Collapse,
  CollapseItem,
  GoodsAction,
  Button,
  Dialog,
  Notify,
  DropdownMenu,
  DropdownItem,
  CellGroup,
  Cell,
  Tag,
  RadioGroup,
  Radio,
  Field,
  Popup,
  Picker,
  DatetimePicker,
  Switch,
} from "vant";
export default {
  name: "OrderDetail",
  components: {
    TransferRecords,
    [Switch.name]: Switch,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [GoodsAction.name]: GoodsAction,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
  },
  data() {
    return {
      moment,
      // eslint-disable-next-line no-undef
      versionConfig,
      orderId: null,
      contactIcon: "star-o",
      activeNames: ["0"], //消费明细展开项
      payActiveNames: ["1"], //收付款展开项
      orderInfo: {},
      isShowCancel: true, //订单中包含已完成的明细，则不能整单取消
      isShowEdit: false, //是否显示修改
      isShowCheckIn: false, //是否显示办理入住
      // total: {
      //   orderMoney: 0, //待收金额
      //   roomMoney: 0, //房间消费金额
      //   paymoney: 0 //已收金额
      // }
      defaultItem: {},
      visiblePrice: false,
      currentItem: {},
      extendValue: "1",
      extendPrice: "",
      companyId: "",
      canUnitRoom: false,
      canSplitRoom: false,
      canTempLeave: false,
      isTempLeaveStatus: false,
      showPicker: false,
      extendDays: "",
      extendDaysValue: 1,
      extendDaysData: [],
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      showDate: false,
      showAllAccount: false,
      showAllPay: false,
    };
  },
  model: {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  created() {
    this.minDate = new Date(this.user.AccountDate);
    const max = moment(this.user.AccountDate)
      .add(5, "year")
      .format("YYYY-MM-DD");
    this.maxDate = new Date(max);
    this.currentDate = new Date(this.user.AccountDate);
    this.orderId = this.$route.query.id;
    this.companyId = this.$route.query.companyId;
    this.getOrderDetail();
    this.getDefaultItem();
  },
  mounted() {},

  watch: {},
  methods: {
    ...mapActions(["setRoomInfo"]),
    getContainer() {
      return document.getElementById("app");
    },
    onTempLeave() {
      jump("OrderCheckOut", { id: this.orderId, type: 3 });
    },
    //获取系统参数值
    getDefaultItem() {
      GetDefaultItem({}).then(res => {
        this.defaultItem = {
          PriceCodeId: res.Data.PriceCodeId,
          isShowTime: res.Data.RoomStatusModel == "0",
          IsIndependentPriceCode: res.Data.IsIndependentPriceCode,
          IsHoldTotalPrice: res.Data.IsHoldTotalPrice,
        };
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
        res.Data.TimeList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    getOrderDetail() {
      let json = {
        id: this.orderId,
      };
      let methodName = orderApi.getOrderDetail;

      if (this.companyId) {
        json.companyId = this.companyId;
        methodName = groupOrderApi.GetGroupOrderDetail;
      }
      methodName(json).then(res => {
        this.orderInfo = res.Data;
        if (this.orderInfo.Pays && this.orderInfo.Pays.length) {
          this.orderInfo.Pays.forEach(ele => {
            ele.AccountDate = moment(ele.AccountDate).format("YYYY-MM-DD");
          });
        }
        if (this.orderInfo.Details && this.orderInfo.Details.length) {
          this.isShowCheckIn = this.orderInfo.Details.some(item => {
            return (
              item.OrderStatus == "0" &&
              moment(item.CheckInDate).isSameOrBefore(this.user.AccountDate)
            );
          });
          this.orderInfo.Details.forEach(item => {
            let total = 0;
            item.Consumes.forEach(el => {
              total += Number(el.TotalPrice);
              el.AccountDate = moment(el.AccountDate).format("YYYY-MM-DD");
            });
            item.total = total.toFixed(2);
            // if (
            //   item.OrderStatus == "0" &&
            //   moment(item.CheckInDate).isSameOrBefore(this.user.AccountDate) &&
            //   !this.isShowCheckIn
            // ) {
            //   this.isShowCheckIn = true;
            // } else {
            //   this.isShowCheckIn = false;
            // }
            if (item.OrderStatus == 2) {
              this.isShowCancel = false;
            }
            item.CheckInTime = moment(item.CheckInTime).format(
              "YYYY-MM-DD HH:mm",
            );
            item.CheckOutTime = moment(item.CheckOutTime).format(
              "YYYY-MM-DD HH:mm",
            );
            item.diffDay =
              moment(item.CheckOutDate).diff(moment(item.CheckInDate), "d") == 0
                ? 1
                : moment(item.CheckOutDate).diff(moment(item.CheckInDate), "d");
          });
          this.canUnitRoom = this.orderInfo.Details.some(
            el => el.OrderStatus == 0 || el.OrderStatus == 1,
          );
          this.canSplitRoom =
            res.Data.Details.length > 1 &&
            res.Data.Details.some(
              el => el.OrderStatus == 0 || el.OrderStatus == 1,
            );
          this.canTempLeave = res.Data.Details.some(
            el =>
              el.OrderStatus == 1 &&
              moment(el.CheckOutDate).isSameOrAfter(this.user.AccountDate),
          );
          this.isTempLeaveStatus = res.Data.Details.some(
            el => el.OrderStatus == 3,
          );
        }
        if (
          this.orderInfo.Status == 4 &&
          (!this.orderInfo.Details || !this.orderInfo.Details.length)
        ) {
          this.canUnitRoom = true;
        }
        //是否显示修改
        this.isShowEdit = res.Data.Status == 0 || res.Data.Status == 1;

        if (res.Data.HasContacted) {
          this.contactIcon = "star";
        }
      });
    },
    ContactGuest(value) {
      let params = {
        Id: this.orderId,
        HasContacted: !value,
      };
      orderApi.editOrderInfo(params).then(() => {
        if (value) {
          this.contactIcon = "star-o";
          Notify("未联系客人");
        } else {
          this.contactIcon = "star";
          Notify({ message: "已联系客人", type: "success" });
        }
        this.orderInfo.HasContacted = !value;
      });
    },
    onCall(phone) {
      Dialog.confirm({
        title: "拨打订单用户电话",
        message: "是否拨打用户电话" + phone,
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + phone;
        })
        .catch(() => {
          // on cancel
        });
    },
    cashDesk() {
      jump("OrderCashDesk", { id: this.orderId });
    },
    checkIn() {
      jump("OrderCheckIn", { id: this.orderId });
    },
    checkOut(type) {
      //1:退房，3：暂离
      //判断是否加收房费
      let json = { OrderId: this.orderId, RoomNos: [] };
      this.orderInfo.Details.forEach(item => {
        json.RoomNos.push(item.RoomNo);
      });
      orderApi.verificationTimeOut(json).then(res => {
        if (res.Data.RentList && res.Data.RentList.length > 0) {
          let isRentIncrease = false;
          for (let index = 0; index < res.Data.RentList.length; index++) {
            if (
              res.Data.RentList[index].IsIncrease == 1 ||
              res.Data.RentList[index].IsIncrease == "1"
            ) {
              isRentIncrease = true;
            }
          }
          if (isRentIncrease) {
            //加收房费
            jump("OrderAddRoomCost", { id: this.orderId, type: type });
          } else {
            //不存在加收房费项
            jump("OrderCheckOut", { id: this.orderId, type: type });
          }
        } else {
          //没有加收信息
          jump("OrderCheckOut", { id: this.orderId, type: type });
        }
      });
    },
    inAccount() {
      jump("OrderInAccount", { id: this.orderId });
    },
    updateOrder() {
      const roomInfo = cloneDeep(this.orderInfo);
      roomInfo.actionType = "update";
      roomInfo.jumpToName = "OrderDetail";
      this.setRoomInfo(roomInfo);
      jump("RoomOrder", { id: this.orderId });
    },
    orderCancle() {
      Dialog.confirm({
        title: "取消订单",
        message: "确定要取消订单吗？取消后可以通过恢复功能进行复原",
      }).then(() => {
        orderApi.cancelOrder({ id: this.orderId }).then(() => {
          Notify({ type: "success", message: "取消订单成功" });
          this.getOrderDetail();
          // jump("OrderPage");
        });
      });
    },
    orderRecover() {
      Dialog.confirm({
        title: "恢复订单",
        message: "确定要恢复订单吗？",
      }).then(() => {
        orderApi.recoverOrder({ OrderId: this.orderId }).then(() => {
          // jump("OrderPage");
          Notify({ type: "success", message: "恢复订单成功" });
          this.getOrderDetail();
        });
      });
    },
    //续住
    orderExtend(item) {
      this.visiblePrice = true;
      this.extendValue = "1";
      const day = moment(item.CheckOutDate)
        .add(1, "d")
        .format("YYYY-MM-DD");
      this.minDate = new Date(day);
      this.currentDate = new Date(day);
      this.extendDays = "";
      this.extendDaysValue = 1;
      this.currentItem = item;
      this.extendPrice = item.DailyPrices[item.DailyPrices.length - 1].Price;
      this.initDaysData(16);
    },
    onTransferEntry() {
      TransferAccountModal({
        defaultItem: this.defaultItem,
        orderId: this.orderId,
        submit: () => {
          this.getOrderDetail();
        },
      });
    },
    openDate() {
      this.showDate = true;
    },
    chooseDate(value) {
      const days = moment(value).diff(
        moment(this.currentItem.CheckOutDate),
        "d",
      );
      this.initDaysData(days);
      this.extendDaysValue = String(days);
      this.extendDays =
        moment(value).format("YYYY-MM-DD (dd)") + "  " + String(days) + "晚";
      this.showDate = false;
    },
    initDaysData(days) {
      this.extendDaysData = [];
      const date = this.currentItem.CheckOutDate;
      this.validRange = [
        moment(date).add(1, "d"),
        moment(date).add(10, "year"),
      ];
      for (let i = 1; i <= days; i++) {
        const day = moment(date)
          .add(i, "day")
          .format("YYYY-MM-DD (dd)");

        const item = {
          value: String(i),
          text: day + "  " + String(i) + "晚",
        };
        this.extendDaysData.push(item);
      }
    },
    confirmExtendDays(sel) {
      this.extendDays = sel.text;
      this.extendDaysValue = sel.value;
      this.showPicker = false;
    },
    submitExtend() {
      const json = {
        OrderDetailId: this.currentItem.Id,
        ExtendDays: this.extendDaysValue,
      };
      if (this.extendValue == "1") {
        json.RoomPrice = this.extendPrice;
      }
      orderApi.OrderExtend(json).then(() => {
        Notify({ type: "success", message: "续住成功" });
        this.getOrderDetail();
      });
    },
    //撤销入住
    orderRevoke(item) {
      const _this = this;
      Dialog.confirm({
        title: "提示",
        message:
          "【撤销入住】操作会清除掉客人账项，清除掉的数据可以在订单日志中查看，是否继续操作？",
      })
        .then(() => {
          orderApi.OrderRevoke({ Id: item.Id }).then(() => {
            Notify({
              type: "success",
              message: "操作成功，订单恢复到预定状态！",
            });
            _this.getOrderDetail();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    jumpToMember() {
      this.$router.push({
        name: "memberInfo",
        query: {
          Id: this.orderInfo.MemberCardId,
        },
      });
    },
    viewTransferRecords(item) {
      this.$refs.TransferRecords.onShow(item.Id);
    },
    onClick() {},
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 0.3rem;
  font-size: 13px;
  color: #999;
  border-bottom: 3px solid #f5f5f9;
  background-color: white;
  .van-row {
    padding: 3px 0;
  }
  .title {
    font-size: 14px;
    font-size: 0.37333rem;
    background: #f2f9ff;
    padding-left: 3px;
    color: #555;
  }
  .amount {
    text-align: right;
    font-size: 12px;
    color: #666;
    .amountColor {
      color: red;
      font-size: 14px;
    }
  }
  .contact {
    font-size: 16px;
    color: #555;
    span {
      font-size: 14px;
      margin-left: 10px;
      color: #999;
    }
    .address {
      color: #009a4a;
    }
  }
  .remark {
    font-size: 12px;
  }
}
.text-right {
  text-align: center;
}
.info-box {
  vertical-align: top;
  label {
    display: inline-block;
    text-align: right;
    width: 53px;
    text-align-last: justify;
  }
  .room-item {
    line-height: 22px;
    height: auto;
    .name {
      font-size: 16px;
      color: #555;
    }
    .status {
      color: #00ac52;
      text-align: right;
    }
  }
}
.check-date {
  font-size: 12px;
}
.consume-detail {
  /deep/.van-cell {
    padding: 0;
    &:not(:last-child)::after {
      left: 0;
    }
  }
  /deep/.van-collapse-item__content {
    padding: 0;
  }
  /deep/.van-collapse-item__title {
    background: #f2f2f2;
    padding-left: 5px;
  }
  table {
    width: 100%;
    font-size: 12px;
    text-align: left;
    th {
      font-weight: normal;
      background: #09a8d1;
      color: #fff;
      text-align: left;
      &:last-child {
        text-align: right;
      }
    }
    td {
      padding: 1px;
    }
  }
}
.pay-detail {
  /deep/.van-collapse-item__title {
    background: #f2f9ff;
    padding-left: 3px;
  }
}
.contacted {
  color: #008eff;
}
/deep/.van-dropdown-menu__title {
  font-weight: bold;
  &::after {
    display: none;
  }
}
.order-drop-menu {
  /deep/ .van-icon {
    color: #868789;
  }
}
.room-content {
  margin-bottom: 5px;
  border-bottom: 1px solid #f4f4f4;
  &:last-child {
    border-bottom: 0;
  }
}
.extend-price {
  padding: 20px;
  .van-radio {
    margin-bottom: 15px;
    height: 36px;
    line-height: 36px;
    .txt-label {
      vertical-align: 9px;
      display: inline-block;
      line-height: 34px;
      height: 34px;
    }
    .txt {
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      width: 150px;
      margin-left: 10px;
      display: inline-block;
    }
  }
}
.detail-zhiyun-version {
  .consume-detail table th {
    background: #4b77b2;
  }
}
.extend-days {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  /deep/.van-cell {
    padding-left: 0;
    padding-right: 0;
    .van-field__label {
      width: 1.8rem;
    }
  }
}
.revoke {
  color: #f00 !important;
}
.show-all {
  position: relative;
  top: 4px;
  margin-right: 10px;
}
.info-box /deep/.van-cell__value {
  flex: 2;
}
</style>
